import { Pipe, PipeTransform } from '@angular/core';
import { formatCNPJ } from '@brazilian-utils/brazilian-utils';

@Pipe({
  name: 'cnpj',
})
export class CnpjPipe implements PipeTransform {
  transform = formatCNPJ;
}
